module.exports = __webpack_public_path__ + "assets/img/loading.64cafa6c.gif";